import React from "react";
import "./UaeReq.css";
const UaeReqMain = () => {
  return (
    <div className="uaeReqMainContainer">
      <div className="uaeReqMainContent">
        <h3>Requirement of UAE Attestation:</h3>
        <p>
          Certificate attestation for UAE visa is required for a variety of
          reasons such as student visa, work visa, residence visa, or for
          professional aspects. It is a part of affirmation that exhibits that
          you are a genuine person or company. It proves that your documents are
          authentic & can be permitted in the country.
        </p>
      </div>
      <div className="uaeReqMainContent">
        <h3>Total time to get certificate attestation for UAE:</h3>
        <p>
          The total time span required depends upon various reasons such as
          which country you necessitate the legalization for, or the sorts of
          documents, or the organization you need it from. It will take approx a
          couple of weeks to a month to accomplish.
        </p>
      </div>
    </div>
  );
};

export default UaeReqMain;
